import React, { useCallback } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useHistory } from 'react-router-dom';
import { ButtonRectangleRadioGroup } from '@yme/atoms/button-select';
import { setFilterOptions, getProductCardLabels, getProductValueByOption, } from '@yme/pdp-components/ProductCard';
import { ROTATION_KEY } from '@yme/selectors/constants';
import { getProductVariantsByColor } from '@yme/selectors/products';
import { FlexWrapper } from '@yme/tokens/flexTokens';
import { RegularTextLevel3, RegularTextLevel4 } from '@yme/tokens/typography';
import { getAvailableSkuByRotationValue, getRotationValues } from './helpers';
export function SelectRotation({ productFilterOptions, variantsOfProduct, }) {
    const productRotationValues = useSelector(getProductValueByOption(ROTATION_KEY));
    const productVariantsByColor = useSelector(getProductVariantsByColor);
    const productCardLabels = useSelector(getProductCardLabels);
    const dispatch = useDispatch();
    const history = useHistory();
    const { sku, rotation, shaftLength = '', colorItemIndex = 0 } = productFilterOptions;
    const onSelectNewValue = useCallback((value) => {
        if (value && rotation !== value) {
            const currentVariant = getAvailableSkuByRotationValue({
                colorVariants: variantsOfProduct,
                rotationValue: value,
                shaftLength,
            });
            if (currentVariant && currentVariant.sku !== sku) {
                dispatch(setFilterOptions({
                    // set main prop
                    rotation: value,
                    // set relative options
                    sku: currentVariant.sku,
                    shaftLength: currentVariant.shaftLength,
                    startingMethod: currentVariant.startingMethod,
                    controlMethod: currentVariant.controlMethod,
                }));
                history.push({
                    hash: currentVariant.sku,
                });
            }
        }
    }, [dispatch, history, rotation, shaftLength, sku, variantsOfProduct]);
    const isCurrentFilterExist = Boolean(productRotationValues && productRotationValues?.length);
    if (rotation && isCurrentFilterExist) {
        const possibleOptions = (productVariantsByColor && productVariantsByColor[colorItemIndex]?.rotationPossibleOptions) ||
            [];
        const formattedProductRotationValues = getRotationValues(productRotationValues);
        const formattedPossibleOptions = getRotationValues(possibleOptions);
        return (React.createElement(FlexWrapper, { mt: "20px", flexDirection: "column" },
            React.createElement(FlexWrapper, { mb: "8px" },
                React.createElement(RegularTextLevel3, { weight: 500 }, productCardLabels?.productCard_rotation_label)),
            React.createElement(FlexWrapper, { flexDirection: "row", gap: "12px" },
                React.createElement(ButtonRectangleRadioGroup, { contentTag: RegularTextLevel4, setActiveOption: onSelectNewValue, allOptions: formattedProductRotationValues, possibleOptions: formattedPossibleOptions, selectedValue: rotation, dataTestId: "rotation", isRadioVisible: true }))));
    }
    return null;
}
SelectRotation.displayName = 'SelectRotation_Component';
